import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputAdornment } from "@mui/material";
import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routes } from "../../constants/routes";
import { StockFilters } from "../../constants/stock-attributes";
import { GoogleServicesContext } from "../../context/GoogleServicesContext";
import { colors } from "../../theme/colors";
import { gaAction, gaCategory } from "../../utils/analytics";
import Input from "../utils/Input";

const SearchButton = ({
  mobile,
  setMobileNavOpen
}: {
  mobile?: boolean;
  setMobileNavOpen?: () => void;
}) => {
  const navigate = useNavigate();
  const { control, handleSubmit, setValue } = useForm();
  const { analyticsEvent } = useContext(GoogleServicesContext);
  const { t } = useTranslation();
  const search = t("header.search");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const searchVal = searchParams.get(StockFilters.Name);

    if (searchVal) {
      setValue(StockFilters.Name, searchVal);
    }
  }, [searchParams, setValue]);

  const onSubmit = (data: unknown) => {
    const { name } = data as { name: string };
    if (!name) {
      return;
    }

    setMobileNavOpen?.();
    analyticsEvent(gaCategory.productsFilter, gaAction.submit);

    navigate(`${routes.products}?${StockFilters.Name}=${name}`);
  };

  return (
    <Box component="form" role="search" onSubmit={handleSubmit(onSubmit)}>
      <Input
        wrapperSx={{ mb: 0 }}
        sx={
          !mobile
            ? {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.white
                },
                " & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: colors.green
                },
                "& .MuiOutlinedInput-input, & ": {
                  color: colors.white
                }
              }
            : undefined
        }
        fullWidth
        id={StockFilters.Name}
        placeholder={search}
        name={StockFilters.Name}
        control={control}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton type="submit" color="inherit" aria-label={search} sx={{ mr: -2 }}>
                <SearchIcon
                  titleAccess={search}
                  sx={(theme) => ({
                    color: mobile
                      ? theme.palette.mode === "light"
                        ? colors.black
                        : colors.white
                      : colors.white
                  })}
                />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </Box>
  );
};

export default SearchButton;
